jQuery(document).ready(function ($) {
  // Images
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var alt = $(this).attr('alt');
    var filename = src.split('/').reverse()[0].replace(/\.[^/.]+$/, '');
    if (img.parent('a').length !== 0) {
      // console.log('parent is a link');
      if (alt === '' || alt === undefined) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (alt === '' || alt === undefined) {
        img.attr('alt', '');
      }
    }
  });

  // Tables
  $('main').responsiveTables();
  //Videos
  $('main').responsivevideos();

  //Forms
  $('.content-form .form-field input').on('keydown', function (e) {
    if ($(this).val().length > 0) {
      $(this).parent().addClass('has-content');
    } else {
      $(this).parent().removeClass('has-content');
    }
  });

  $('.content-form .form-field textarea').on('keydown', function (e) {
    if ($(this).val().length > 0) {
      $(this).parent().addClass('has-content');
    } else {
      $(this).parent().removeClass('has-content');
    }
  });

  $('.content-form .form-field select').on('change', function (e) {
    if ($(this).val().length > 0) {
      $(this).parent().addClass('has-content');
    } else {
      $(this).parent().removeClass('has-content');
    }
  });

  $('.loc-show-all .btn').on('click', function () {
    $('.providers').toggleClass('show-all');
  });

  $('.mobile-filter-dropdown').on('click', function () {
    $('body').toggleClass('filter-menu-open');
  });
});